import ClassHelper from '../ClassHelper';

class ExcursionSeo extends ClassHelper {
  constructor({ title, description, keywords } = {}) {
    super(...arguments);
    this.title = title;
    this.description = description;
    this.keywords = keywords;
  }
}

export default ExcursionSeo;